<template>
  <div>
    <article
      :class="{
        comment: true,
        pinned: comment.pinned,
        highlighted: highlighted
      }"
      v-if="!isEmpty"
    >
      <div class="content-wrapper full" ref="content-wrapper">
        <div :class="{
          content: true,
          closed: comment.closed,
          invis: comment.hidden,
          selected: isSelected,
          notif: hasNotification,
        }">
          <div
            v-if="comment.replies.length > 0"
            class="hide-row flexrow"
          >
            <div
              class="filler left20"
              @click="collapsed = !collapsed"
            >
              <span v-if="comment.title">
                {{ comment.title }}
              </span>
              <chevrons-right-icon
                class="arrows-icon"
                v-if="collapsed"
                size="14"
              />
              <chevrons-down-icon
                class="arrows-icon"
                v-else
                size="14"
              />
            </div>
            <div class="flexrow-item menu-wrapper">
              <span class="pinned-text" v-if="comment.pinned">
                {{ $t('comments.pinned') }}
              </span>
              <menu-icon size="14" class="menu-icon" @click="toggleCommentMenu" />
              <comment-menu
                :is-pinned="comment.pinned"
                :is-editable="editable"
                :is-closed="comment.closed"
                :is-hidden="comment.hidden"
                @close-clicked="
                  $emit('close-comment', comment)
                  toggleCommentMenu()
                "
                @hide-clicked="
                  $emit('hide-comment', comment)
                  toggleCommentMenu()
                "
                @pin-clicked="$emit('pin-comment', comment)"
                @edit-clicked="
                  $emit('edit-comment', comment)
                  toggleCommentMenu()
                "
                @delete-clicked="
                  $emit('delete-comment', comment)
                  toggleCommentMenu()
                "
                ref="menu"
              />
            </div>
            <input
              type="checkbox"
              class="flexrow-item checkbox"
              @change="onChecked"
            />
          </div>
          <div
            :class="{
              'com-box': true,
              'full-com': comment.replies.length === 0,
              'right-com': user.id === comment.person_id,
              'left-com': user.id !== comment.person_id,
              'highlighted': currentHighlights.has(comment.id)
            }"
          >
            <div 
              :class="{
                'flexrow': true,
                'header': true,
              }"
            >
              <!-- <validation-tag
                class="flexrow-item"
                :task="{ task_status_id: comment.task_status.id }"
                :is-static="true"
                :thin="!isChange"
              /> -->
              <people-avatar
                class="flexrow-item"
                :size="32"
                :font-size="15"
                :person="comment.person"
              />
              <strong class="flexrow-item">
                <people-name
                  :person="comment.person"
                />
              </strong>
              <div class="filler"></div>
              <span class="client-comment" v-if="isAuthorClient(comment) && !isCurrentUserClient">
                {{ $t('comments.comment_from_client') }}
                <copy-icon
                  class="copy-icon"
                  size="1.1x"
                  @click="$emit('duplicate-comment', comment)"
                />
              </span>
              <div v-if="comment.original" class="flexrow-item flexrow original">
                <span class="flexrow-item">
                  Original:&nbsp;&nbsp;
                </span>
                <template v-if="comment.original.object_id !== comment.object_id">
                  <span class="flexrow-item" v-if="originalEntity.episode && taskMap.get(comment.object_id).episode_id !== originalEntity.episode_id">
                    {{ originalEntity.episode.name }} -&nbsp;
                  </span>
                  <span class="flexrow-item">
                    {{ `${originalEntity.sequence_name} - ${originalEntity.entity.name} - ${originalEntity.task_type.name} -` }}&nbsp;
                  </span>
                </template>
                <span class="flexrow-item">
                  v{{ comment.original.revision  || 0 }}
                </span>
              </div>
              <span class="flexrow-item date" :title="fullDate">
                {{ shortDate }}
              </span>
              <div 
                v-if="comment.replies.length === 0"
                class="flexrow-item menu-wrapper">
                <span class="pinned-text" v-if="comment.pinned">
                  {{ $t('comments.pinned') }}
                </span>
                <menu-icon size="14" class="menu-icon" @click="toggleCommentMenu" />
                <comment-menu
                  :is-pinned="comment.pinned"
                  :is-editable="editable"
                  :is-closed="comment.closed"
                  :is-hidden="comment.hidden"
                  @close-clicked="
                    $emit('close-comment', comment)
                    toggleCommentMenu()
                  "
                  @hide-clicked="
                    $emit('hide-comment', comment)
                    toggleCommentMenu()
                  "
                  @pin-clicked="$emit('pin-comment', comment)"
                  @edit-clicked="
                    $emit('edit-comment', comment)
                    toggleCommentMenu()
                  "
                  @delete-clicked="
                    $emit('delete-comment', comment)
                    toggleCommentMenu()
                  "
                  ref="menu"
                />
                <input
                  type="checkbox"
                  class="flexrow-item checkbox"
                  @change="onChecked"
                />
              </div>
            </div>
            <div>
              <p
                v-html="
                  renderComment(
                    comment.text,
                    comment.mentions,
                    comment.department_mentions || [],
                    personMap,
                    departmentMap,
                    uniqueClassName
                  )
                "
                class="comment-text"
                v-if="comment.text"
              ></p>
              <checklist
                class="checklist"
                :checklist="checklist"
                :timecode-name="uniqueClassName"
                :mentions="comment.mentions"
                :department-mentions="comment.department_mentions"
                @time-code-clicked="timeCodeClicked"
                @remove-task="removeTask"
                @keyup.native="emitChangeEvent($event)"
                @emit-change="emitChangeEvent"
                :disabled="true"
                v-if="checklist.length > 0"
              />
              <!-- <p class="has-text-centered" v-if="taskStatus.is_done && isLast">
                <img
                  class="congrats-picture"
                  src="../../assets/illustrations/validated.png"
                />
              </p> -->
              <div
                class="attachments"
                v-if="comment.attachment_files.length > 0"
                ref="attachments"
              >
                <a
                  :href="getAttachmentPath(attachment)"
                  :key="attachment.id"
                  :title="attachment.name"
                  target="_blank"
                  v-for="attachment in pictureAttachments"
                >
                <div class="imggohere">
                  <img
                    class="attachment"
                    :src="getAttachmentPath(attachment)"
                    :style="{ width: imgStyleWidth }"
                  />
                </div>
                </a>
                <a
                  :href="getAttachmentPath(attachment)"
                  :key="attachment.id"
                  :title="attachment.name"
                  class="flexrow"
                  target="_blank"
                  v-for="attachment in fileAttachments"
                >
                  <paperclip-icon
                    size="1x"
                    class="flexrow-item attachment-icon"
                  />
                  <span class="flexrow-item">
                    {{ attachment.name }}
                  </span>
                </a>
              </div>
            </div>
          </div>
          <!-- <transitionGroup> -->
            <template v-if="!collapsed">
              <div
                v-for="replyComment in comment.replies || []"
                :key="replyComment.id"
                :class="{
                  'com-box': true,
                  'right-com': user.id === replyComment.person_id,
                  'left-com': user.id !== replyComment.person_id,
                  'highlighted': currentHighlights.has(replyComment.id)
                }"
              >
                <div
                  :class="{
                    'flexrow': true,
                    'header': true,
                  }"
                >
                  <people-avatar
                    class="flexrow-item"
                    :size="32"
                    :font-size="15"
                    :person="personMap.get(replyComment.person_id)"
                  />
                  <strong class="flexrow-item">
                    <people-name
                      :person="personMap.get(replyComment.person_id)"
                    />
                  </strong>
                  <div class="filler"></div>
                  <span class="client-comment" v-if="isAuthorClient(replyComment) && !isCurrentUserClient">
                    {{ $t('comments.comment_from_client') }}
                    <copy-icon
                      class="copy-icon"
                      size="1.1x"
                      @click="$emit('duplicate-comment', comment)"
                    />
                  </span>
                  <div class="filler" v-if="isAuthorClient(replyComment) && !isCurrentUserClient"></div>
                  <span
                    class="flexrow-item date"
                    :title="replyFullDate(replyComment.date)"
                  >
                    {{ replyShortDate(replyComment.date) }}
                  </span>
                  <span
                    class="flexrow-item reply-delete"
                    :title="$t('main.delete')"
                    @click="onDeleteReplyClicked(replyComment)"
                    v-if="
                      isCurrentUserAdmin || replyComment.person_id === user.id
                    "
                  >
                    x
                  </span>
                </div>
                <p
                  v-html="
                    renderComment(
                      replyComment.text,
                      replyComment.mentions || [],
                      replyComment.department_mentions || [],
                      personMap,
                      departmentMap,
                      ''
                    )
                  "
                  class="comment-text"
                ></p>
              </div>
            </template>
          <!-- </transitionGroup> -->
          <div
            v-else
            class="hide-row flexrow"
          >
            <div
              class="filler"
              @click="collapsed = false"
            >
              <more-horizontal-icon size="14" />
            </div>
          </div>
          <at-ta
            v-if="!comment.closed"
            :members="atOptions"
            name-key="full_name"
            :limit="2"
            @input="onAtTextChanged"
          >
            <template slot="item" slot-scope="team">
              <template v-if="team.item.isTime"> ⏱️ frame </template>
              <template v-else>
                <div class="flexrow">
                  <people-avatar
                    class="flexrow-item"
                    :person="team.item"
                    :size="18"
                    :font-size="10"
                    :no-cache="true"
                    :is-link="false"
                  />
                  <span class="flexrow-item">
                    {{ team.item.full_name }}
                  </span>
                </div>
              </template>
            </template>
            <textarea
              ref="reply"
              class="reply"
              @keyup.ctrl.enter="onReplyClicked"
              v-model="replyText"
              v-show="showReply"
            />
          </at-ta>
          <button-simple
            v-if="!comment.closed"
            class="reply-button"
            :text="$t('main.reply')"
            :is-loading="isReplyLoading"
            @click="onReplyClicked"
            v-show="showReply"
          />

          <div
            class="flexrow reply-button-row"
            v-if="!showReply && !comment.closed && (comment.text.length > 0 || comment.previews.length > 0)"
          >
            <!-- <button
              :class="{
                'like-button': true,
                'like-button--empty':
                  comment.like === undefined ? true : false,
                'flexrow-item': true
              }"
              @click="acknowledgeComment(comment)"
              type="button"
            >
              <thumbs-up-icon size="1x" />
              <span>{{ comment.acknowledgements.length }}</span>
            </button> -->
            <!-- <span class="filler noclick"> </span> -->
            <corner-up-right-icon
              size="18"
              clss="flexrow-item reply-icon"
            />
            <span
              class="flexrow-item reply-button"
              @click="showReplyWidget"
            >
              {{ $t('main.reply') }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="flexrow content-wrapper preview-info"
        v-if="comment.previews.length > 0"
      >
        <router-link
          class="flexrow-item round-name revision"
          :to="previewRoute"
        >
          Revision {{ comment.previews[0].revision }}
        </router-link>
        <span
          class="flexrow-item preview-status"
          :title="comment.previews[0].validation_status"
          :style="getPreviewValidationStyle(comment.previews[0])"
          @click="changePreviewValidationStatus(comment.previews[0])"
        >
          &nbsp;
        </span>
      </div>
    </article>
    <div class="empty-comment" v-else>
      <div class="flexrow content-wrapper">
        <!-- <validation-tag
          class="flexrow-item"
          :task="{ task_status_id: comment.task_status.id }"
          :is-static="true"
          :thin="!isChange"
        /> -->
        <people-avatar
          class="flexrow-item"
          :person="comment.person"
          :size="32"
          :font-size="15"
        />
        <people-name class="flexrow-item" :person="comment.person" />
        <span class="filler"> </span>
        <div v-if="comment.original" class="flexrow-item flexrow original">
          <span class="flexrow-item">
            Original:&nbsp;&nbsp;
          </span>
          <template v-if="comment.original.object_id !== comment.object_id">
            <span class="flexrow-item" v-if="originalEntity.episode && taskMap.get(comment.object_id).episode_id !== originalEntity.episode_id">
              {{ originalEntity.episode.name }} -&nbsp;
            </span>
            <span class="flexrow-item">
              {{ `${originalEntity.sequence_name} - ${originalEntity.entity.name} - ${originalEntity.task_type.name} -` }}&nbsp;
            </span>
          </template>
          <span class="flexrow-item">
            v{{ comment.original.revision  || 0 }}
          </span>
        </div>
        <span class="flexrow-item date" :title="fullDate">
          {{ shortDate }}
        </span>
        <div class="flexrow-item menu-wrapper">
          <p class="pinned-text" v-if="comment.pinned">
            {{ $t('comments.pinned') }}
          </p>
          <menu-icon size="14" class="menu-icon" @click="toggleCommentMenu" />
          <comment-menu
            :is-editable="editable"
            :is-empty="true"
            :is-closed="false"
            :is-hidden="comment.hidden"
            @close-clicked="
              $emit('close-comment', comment)
              toggleCommentMenu()
            "
            @hide-clicked="
              $emit('hide-comment', comment)
              toggleCommentMenu()
            "
            @pin-clicked="$emit('pin-comment', comment)"
            @edit-clicked="
              $emit('edit-comment', comment)
              toggleCommentMenu()
            "
            @delete-clicked="
              $emit('delete-comment', comment)
              toggleCommentMenu()
            "
            ref="menu"
          />
          <input
            type="checkbox"
            class="flexrow-item checkbox"
            @change="onChecked"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AtTa from 'vue-at/dist/vue-at-textarea'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { remove } from '@/lib/models'
import { renderComment, replaceTimeWithTimecode } from '@/lib/render'
import { sortByName } from '@/lib/sorting'
import { formatDate, parseDate } from '@/lib/time'
import colors from '@/lib/colors'
import files from '@/lib/files'
import { pluralizeEntityType } from '@/lib/path'

import {
  CopyIcon,
  CornerUpRightIcon,
  ChevronsRightIcon,
  ChevronsDownIcon,
  MenuIcon,
  MoreHorizontalIcon,
  PaperclipIcon
} from 'vue-feather-icons'
import CommentMenu from '@/components/widgets/CommentMenu'
import ButtonSimple from '@/components/widgets/ButtonSimple'
import Checklist from '@/components/widgets/Checklist'
import PeopleAvatar from '@/components/widgets/PeopleAvatar'
import PeopleName from '@/components/widgets/PeopleName'
import { comment } from 'postcss'

const READ_TIME_CODE_REGEX = /v(\d+) \d+:\d+\.\d+ \((\d+)\)(.*)/

export default {
  name: 'comment',
  components: {
    AtTa,
    ButtonSimple,
    Checklist,
    CopyIcon,
    ChevronsRightIcon,
    ChevronsDownIcon,
    MenuIcon,
    MoreHorizontalIcon,
    CommentMenu,
    CornerUpRightIcon,
    PaperclipIcon,
    PeopleAvatar,
    PeopleName
  },

  data() {
    return {
      atOptions: [],
      checklist: [],
      currentHighlights: new Set(),
      commentsByFrame: new Map(),
      collapsed: this.comment.closed,
      isReplyLoading: false,
      isSelected: false,
      replyText: '',
      showReply: false,
      uniqueClassName: (Math.random() + 1).toString(36).substring(2),
      observer: null,
      imgStyleWidth: 'auto',
    }
  },

  props: {
    comment: {
      type: Object,
      default: () => {}
    },
    team: {
      type: Array,
      default: () => []
    },
    task: {
      type: Object,
      default: null
    },
    highlighted: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    isChange: {
      type: Boolean,
      default: false
    },
    frame: {
      type: Number,
      default: null
    },
    revision: {
      type: Number,
      default: 1
    },
    fps: {
      type: Number,
      default: 25
    },
    time: {
      type: Number,
      default: 0
    },
  },

  mounted() {
    if (this.comment.checklist) {
      this.$options.silent = true
      this.checklist = [...this.comment.checklist]
      this.$nextTick().then(() => {
        this.$options.silent = false
      })
    }
    Array.from(document.getElementsByClassName(this.uniqueClassName)).forEach(
      element => {
        element.addEventListener('click', this.timeCodeClicked)
      }
    )
    this.indexCommentTimecodes(this.comment)
    this.comment.replies.forEach(this.indexCommentTimecodes)
    if (this.$refs["attachments"]) {
      this.observer = new ResizeObserver(this.setImgStyle)
      this.observer.observe(this.$refs["content-wrapper"])
    }
  },

  destroyed() {
    Array.from(document.getElementsByClassName(this.uniqueClassName)).forEach(
      element => {
        element.removeEventListener('click', this.timeCodeClicked)
      }
    )
    if (this.observer) {
      this.observer.unobserve(this.$refs["content-wrapper"])
      this.observer = null
    }
  },

  computed: {
    ...mapGetters([
      'currentProduction',
      'departmentMap',
      'isCurrentUserAdmin',
      'isCurrentUserClient',
      'isCurrentUserManager',
      'isDarkTheme',
      'user',
      'taskMap',
      'notifications',
      'personMap',
      'productionDepartmentIds',
      'taskTypeMap',
      'taskStatusMap'
    ]),

    originalEntity() {
      if (!this.comment.original) { return null }
      return this.taskMap.get(this.comment.original.object_id)
    },

    hasNotification() {
      return this.notifications.findIndex(n => n.comment_id === this.comment.id && !n.read) > -1
    },

    isEmpty() {
      return (
        this.comment.text.length === 0 &&
        (!this.comment.checklist || this.comment.checklist.length === 0) &&
        this.comment.attachment_files.length === 0 &&
        this.comment.previews.length === 0 &&
        !(this.isFirst && this.taskStatus.is_done)
      )
    },

    previewRoute() {
      let route = {
        name: 'task',
        params: {
          task_id: this.comment.object_id,
          production_id: this.currentProduction.id
        }
      }
      if (this.comment.previews.length > 0) {
        route = {
          name: 'task-preview',
          params: {
            task_id: this.comment.object_id,
            preview_id: this.comment.previews[0].id,
            production_id: this.currentProduction.id
          }
        }
      }
      if (this.$route.params.episode_id) {
        route.name = `episode-${route.name}`
        route.params.episode_id = this.$route.params.episode_id
      }
      const taskType = this.taskTypeMap.get(this.task.task_type_id)
      route.params.type = pluralizeEntityType(taskType.for_entity)
      return route
    },

    deleteCommentPath() {
      return this.getPath('task-delete-comment')
    },

    editCommentPath() {
      return this.getPath('task-edit-comment')
    },

    addPreviewPath() {
      return this.getPath('task-add-preview')
    },

    taskStatus() {
      const status = this.taskStatusMap.get(this.comment.task_status.id)
      return status || this.comment.task_status
    },

    isAddChecklistAllowed() {
      return (
        this.taskStatus.is_retake &&
        this.checklist.length === 0 &&
        this.user.id === this.comment.person_id
      )
    },

    isChangeChecklistAllowed() {
      return (
        this.taskStatus.is_retake && this.user.id === this.comment.person_id
      )
    },

    isLikedBy() {
      const personList = this.comment.acknowledgements.map(personId =>
        this.personMap.get(personId)
      )
      return sortByName(personList)
        .map(p => p.name)
        .join(', ')
    },

    pictureAttachments() {
      return [...this.comment.attachment_files]
        .sort((a, b) => a.name.localeCompare(b.name))
        .filter(attachment => {
          return files.IMG_EXTENSIONS.includes(attachment.extension)
        })
    },

    fileAttachments() {
      return this.comment.attachment_files.filter(attachment => {
        return !files.IMG_EXTENSIONS.includes(attachment.extension)
      })
    },

    commentDate() {
      return parseDate(this.comment.created_at)
    },

    fullDate() {
      return this.commentDate
        .tz(this.user.timezone)
        .format('YYYY-MM-DD HH:mm:ss')
    },

    shortDate() {
      return this.renderDate(this.commentDate)
    },

    statusColor() {
      const color = this.comment.task_status.color
      if (this.isDarkTheme && !this.isEmpty) {
        return colors.darkenColor(color)
      } else {
        return color
      }
    },
  },

  methods: {
    ...mapActions([
      'deleteReply',
      'replyToComment',
      'updatePreviewFileValidationStatus'
    ]),

    onChecked(event) {
      this.isSelected = event.target.checked
      this.$emit('select', event.target.checked)
    },

    setImgStyle () {
      const outerWidth = this.$refs["content-wrapper"].clientWidth
      this.imgStyleWidth = outerWidth < 700 ? "300px" : "auto"
    },

    indexCommentTimecodes(reply) {
      if (reply.text) {
        const times = reply.text.match(READ_TIME_CODE_REGEX)
        if (times && times.length > 3) {
          const rev = Number(times[1])
          const frm = Number(times[2])
          if (this.commentsByFrame.has(frm)) {
            var entry = this.commentsByFrame.get(frm)
            if (entry.has(rev)) {
              var eentry = entry.get(rev)
              eentry.push(reply.id)
              entry.set(rev, eentry)
            } else {
              entry.set(rev, [ reply.id ])
            }
          } else {
            this.commentsByFrame.set(frm, new Map( [[ rev, [ reply.id ] ]] ))
          }
        }
      }
    },

    formatDate(date) {
      return formatDate(date)
    },

    replyFullDate(date) {
      return moment(parseDate(date))
        .tz(this.user.timezone)
        .format('YYYY-MM-DD HH:mm:ss')
    },

    replyShortDate(date) {
      return this.renderDate(parseDate(date))
    },

    renderDate(date) {
      date = moment(date)
      if (moment().isSame(date, 'd')) {
        return date.tz(this.user.timezone).format('HH:mm')
      } else {
        return date.tz(this.user.timezone).format('MM/DD')
      }
    },

    isAuthorClient(comment) {
      return this.personMap.get(comment.person_id).role === 'client'
    },

    getCommentStyle(comment) {
      const author = this.personMap.get(comment.person_id)
      return {
        background: colors.hexToRGBa(author.color, 0.2)
      } 
    },

    getPath(name) {
      const route = {
        name: name,
        params: {
          task_id: this.comment.object_id,
          comment_id: this.comment.id
        }
      }
      if (this.$route.params.episode_id) {
        route.name = `episode-${route.name}`
        route.params.episode_id = this.$route.params.episode_id
      }
      return route
    },

    getAttachmentPath(attachment) {
      return (
        `/api/data/attachment-files/${attachment.id}/` +
        `file/${attachment.name}`
      )
    },

    toggleCommentMenu() {
      this.$refs.menu.toggle()
    },

    addChecklistEntry() {
      this.$options.silent = true
      this.checklist.push({
        text: '',
        checked: false
      })
      this.$nextTick().then(() => {
        this.$options.silent = false
      })
    },

    removeTask(entry) {
      this.checklist = remove(this.checklist, entry)
    },

    emitChangeEvent(event) {
      const now = new Date().getTime()
      this.lastCall = this.lastCall || 0
      if (now - this.lastCall > 1000) {
        this.lastCall = now
        this.$emit(
          'checklist-updated',
          this.comment,
          this.checklist.filter(item => item.text && item.text.length > 0)
        )
      }
    },

    acknowledgeComment(comment) {
      this.$emit('ack-comment', comment)
    },

    timeCodeClicked(event) {
      this.$emit('time-code-clicked', event.target.dataset)
    },

    getPreviewValidationStyle(previewFile) {
      let color = '#AAA'
      if (previewFile.validation_status === 'validated') {
        color = '#67BE48' // green
      } else if (previewFile.validation_status === 'rejected') {
        color = '#FF3860' // red
      }
      return { background: color }
    },

    changePreviewValidationStatus(previewFile) {
      if (!this.isCurrentUserManager) return
      let status = previewFile.status
      if (previewFile.validation_status === 'validated') {
        status = 'rejected'
      } else if (previewFile.validation_status === 'rejected') {
        status = 'neutral'
      } else {
        status = 'validated'
      }
      this.updatePreviewFileValidationStatus({ previewFile, status })
    },

    renderComment,

    showReplyWidget() {
      this.showReply = true
      this.$nextTick(() => {
        this.$refs.reply.focus()
      })
    },

    onReplyClicked() {
      this.isReplyLoading = true
      this.replyToComment({ comment: this.comment, text: this.replyText })
        .then(() => {
          this.isReplyLoading = false
          this.replyText = ''
          this.showReply = false
        })
        .catch(console.error)
    },

    onDeleteReplyClicked(reply) {
      this.deleteReply({ comment: this.comment, reply })
        .then(() => {
          this.isReplyLoading = false
        })
        .catch(console.error)
    },

    onAtTextChanged(input) {
      if (input.indexOf('@frame') >= 0) {
        this.$nextTick(() => {
          const text = replaceTimeWithTimecode(
            this.$refs['comment-textarea'].value,
            this.revision,
            this.time,
            this.fps
          )
          this.$refs['comment-textarea'].value = text
        })
      }
    }
  },

  watch: {
    'comment.checklist'() {
      this.$options.silent = true
      this.checklist = [...this.comment.checklist]
      this.$nextTick().then(() => {
        this.$options.silent = false
      })
    },

    'comment.closed'() {
      this.collapsed = this.comment.closed
    },

    checklist() {
      if (!this.$options.silent) {
        this.emitChangeEvent()
      }
    },

    frame () {
      if (this.commentsByFrame.has(this.frame)) {
        const comsByRev = this.commentsByFrame.get(this.frame)
        if (comsByRev.has(this.revision)) {
          this.currentHighlights = new Set(comsByRev.get(this.revision))
          return
        }
      }
      if (this.currentHighlights.size) {
        this.currentHighlights = new Set()
      }
    },

    team: {
      deep: true,
      immediate: true,
      handler() {
        if (this.isCurrentUserClient) {
          this.atOptions = this.team.filter(person =>
            ['admin', 'manager', 'supervisor', 'client'].includes(person.role)
          )
        } else {
          this.atOptions = [...this.team]
        }
        this.atOptions = this.atOptions.concat(
          this.productionDepartmentIds.map(departmentId => {
            const department = this.departmentMap.get(departmentId)
            return {
              isDepartment: true,
              full_name: department.name,
              color: department.color,
              id: departmentId
            }
          })
        )
        this.atOptions.push({
          isTime: true,
          full_name: 'frame'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dark {
  .content {
    background: $dark-grey;
  }

  .comment-text {
    color: $white-grey;
  }

  .add-checklist {
    background: $dark-grey-lighter;
  }

  .header {
    color: $white;
  }

  .content.closed {
    background: #585858;
  }

  .content.invis {
    background: #57455e;
  }

  .content.selected {
    background: #0f65af;
  }

  .content.notif {
    background: #dd2727;
  }

  .com-box.highlighted {
    border: 2px solid rgb(113, 201, 132);
  }

  .hide-row {
    color: $grey;
  }
}

@keyframes scale-in {
  0% {
    height: 0;
    opacity: 0;
    position: absolute;
  }
  1% {
    height: 0;
    opacity: 0;
    position: relative;
  }
  100% {
    height: 4em;
    opacity: 1;
  }
}

.v-enter-active {
  animation: scale-in 0.1s ease-out forwards;
}

.v-leave-active {
  animation: scale-in 0.1s ease-out reverse;
}

.v-leave-to {
  opacity: 0;
  position: absolute;
}

.comment-menu {
  color: var(--text);
}

.hide-row {
  height: 1.5em;
  color: $dark-grey-lighter;
  text-align: center;
}

.header {
  color: $dark-grey-lightest;
  text-wrap: nowrap;
}

.com-box {
  // border: 1px solid $light-grey;
  border-radius: 0.5em;
  margin-bottom: 0.2em;
  padding: 0.2em;
}

.com-box.highlighted {
  border: 2px solid rgb(113, 201, 132);
}

.date {
  padding-top: 1px;
  font-size: 0.8em;
  color: inherit;
}

.right-com {
  margin-left: 2.4em;
  // border: 1px solid #c671ff;
  background: hsla(197, 100%, 52%, 0.1);
}

.left-com {
  margin-right: 2.4em;
  // border: 1px solid #8bbdff
  background: rgba(180, 180, 180, 0.1);
}

.full-com {
  margin-right: 0;
  margin-left: 0;
}

.comment {
  // background: white;
  border-radius: 10px;
  padding: 0;
  word-wrap: anywhere;
  hyphens: auto;
}

.media {
  padding: 0.6em;
}

.avatar {
  margin: 2px;
}

.content .comment-person {
  min-height: 40px;
  margin-bottom: 0;
}

.comment-date {
  color: $grey;
  margin-left: 0.5em;
  flex: 1;
}

.content {
  .comment-text {
    margin-top: 0.5rem;
    margin-bottom: 0rem;
    padding: 0.2em 0.1em;
    word-break: break-word;
    hyphens: auto;
    hyphenate-limit-chars: 8 6 2;
  }
  background: $white;
  border: 1px solid $grey;
  border-radius: 0.5em;
  padding: 0;
  flex: 1;
  margin-bottom: 1em;
  padding-bottom: 2px;
}

.content.closed {
  background: #d6d6d6;
}

.content.invis {
  background: #d1b9da;
}

.content.selected {
  background: #5a9eda;
  box-shadow: -4px 4px 3px #0000005c;
  translate: 2px -2px;
}

.comment-text.empty {
  font-style: italic;
  color: #AAA;
}

.content.notif {
  background: #ffb3b3;
}

.menu-icon {
  width: 20px;
  cursor: pointer;
  color: inherit;
}

.menu-wrapper {
  position: relative;
}

.noclick {
  pointer-events: none;
}

.left20 {
  margin-left: 20px;
}

.pinned {
  transform: scale(1.02);
}

.pinned-text {
  font-size: 0.8em;
  margin: 0;
  text-align: right;
  color: $light-grey;
}

.add-checklist {
  background: $white-grey-light;
  color: $grey;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 0.8em;
  padding: 0.5em;
}

.client-comment {
  // background: #ec7891bb;
  background: none;
  color: white;
  border-radius: 4px 4px 0 0;
  // font-size: 0.8em;
  padding: 0.3em 0;
  text-transform: uppercase;
}

.task-status-name {
  margin-top: auto;
  font-size: 0.8em;
  text-transform: uppercase;
}

.flexrow {
  align-items: stretch;
}

.comment-left {
  display: flex;
  flex-direction: column;
  padding: 0.5em 0 0.5em 0.5em;
}

.like-button {
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  border: 0;
  border-radius: 0.5rem;
  color: inherit;
  cursor: pointer;
  display: inline-flex;
  margin: 0;
  padding: 0.3rem 0;
  width: 100%;
  z-index: 10;

  &:hover,
  &:focus {
    background-color: $dark-grey-lightest;
  }

  &[disabled] {
    pointer-events: none;
  }

  span {
    margin-left: 0.3em;
  }
}

.like-button--empty {
  opacity: 0.5;

  &:hover,
  &:focus {
    opacity: 1;
  }
}

.comment-like {
  cursor: pointer;
  margin-left: 0.5em;
}

.infos {
  display: flex;
  align-items: center;
}

.reply-button-row {
  // margin-top: -2em;
  padding-bottom: 0.5em;
}

.reply-button {
  border-radius: 5px;
  color: var(--text);
  cursor: pointer;
  font-size: 0.9em;
  padding-left: 0.5em;
  width: 60px;
}

.reply-button.button {
  margin: 0 0 0.5em 0.5em;
}

img {
  max-width: 100%;
  height: auto;
}

textarea.reply {
  background: $white;
  border: 1px solid var(--border);
  border-radius: 5px;
  color: $black;
  font-size: 0.9em;
  margin-top: 0.5em;
  margin-left: 0.5em;
  padding: 0.5em;
  width: calc(100% - 0.5em);
}

strong {
  color: inherit;
}

.person-name {
  color: inherit;
  line-height: 36px;
  margin-left: 4px;
  text-transform: none;
}

.reply-delete {
  color: inherit;
  cursor: pointer;
  text-align: center;
  margin-top: -2px;
  margin-right: 0px;
  height: 20px;
  width: 20px;
}

.preview-status {
  border-radius: 50%;
  border: 2px solid $grey;
  cursor: pointer;
  height: 20px;
  width: 20px;
}

.imggohere {
  max-width: 650px;
}
img {
  max-width: 650px;
}

.attachments {
  width: fit-content;
}

.original {
  background: rgba(128, 128, 128, 0.199);
  padding: 3px;
  height: 20pt;
  text-wrap: nowrap;
  min-width: 0;
  overflow: hidden;
  span {
    margin: 0;
  }
  :first-child {
    min-width: 0;
    overflow: hidden;
  }
}

@media screen and (max-width: 768px) {
  .flexrow {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
